import type { CSSProperties } from "react";

import type { ChapterBoard } from "@/lib/timeline/board";
import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import type { PlaybackState } from "@/lib/timeline/playback";
import type { TimelineViewTransform } from "@/lib/timeline/view/ViewTransform/transform";
import {
  TIMELINE_WORLD_HEIGHT_PX,
  TIMELINE_WORLD_WIDTH_PX,
} from "@/lib/timeline/view/WorldMetrics/metrics";
import { BoardTimelineOverlays } from "./BoardTimelineOverlays";
import { ChapterTickLabels } from "./ChapterTickLabels";
import { LayoutTimelineOverlays } from "./LayoutTimelineOverlays";

interface BookTimelineMarkersProps {
  canvas: HTMLCanvasElement | null;
  layout: BookTimelineLayout;
  chapterBoard?: ChapterBoard;
  boardModelDebug: boolean;
  getPlayback: () => PlaybackState;
  getViewportWidth: () => number;
  getViewportHeight: () => number;
  getViewTransform: () => TimelineViewTransform;
}

export function BookTimelineMarkers({
  canvas,
  layout,
  chapterBoard,
  boardModelDebug,
  getPlayback,
  getViewportWidth,
  getViewportHeight,
  getViewTransform,
}: BookTimelineMarkersProps) {
  const view = getViewTransform();
  const zoomStyle = {
    "--timeline-zoom": view.zoom,
    "--timeline-pan-x": `${view.panX}px`,
    "--timeline-pan-y": `${view.panY}px`,
  } as CSSProperties;
  const worldStyle = {
    "--timeline-world-width": `${TIMELINE_WORLD_WIDTH_PX}px`,
    "--timeline-world-height": `${TIMELINE_WORLD_HEIGHT_PX}px`,
  } as CSSProperties;

  return (
    <div className="timeline-stage__zoom" style={zoomStyle}>
      <div className="timeline-stage__world" style={worldStyle}>
        {chapterBoard !== undefined ? (
          <BoardTimelineOverlays
            canvas={canvas}
            board={chapterBoard}
            layout={layout}
            getPlayback={getPlayback}
            getViewportWidth={getViewportWidth}
            getViewportHeight={getViewportHeight}
            getViewTransform={getViewTransform}
            boardModelDebug={boardModelDebug}
          />
        ) : (
          <LayoutTimelineOverlays
            canvas={canvas}
            layout={layout}
            getPlayback={getPlayback}
            getViewportWidth={getViewportWidth}
            getViewportHeight={getViewportHeight}
            getViewTransform={getViewTransform}
          />
        )}
        <ChapterTickLabels
          canvas={canvas}
          layout={layout}
          getViewportWidth={getViewportWidth}
        />
      </div>
    </div>
  );
}
